import React, { useEffect, useState } from 'react'
import InvoiceService from '../../../../../services/api/invoice.service'
import ModalBox from '../../../../templates/components/ModalBox'
import VirtualTerminalForm from '../../transactions/terminals/virtual-terminal/virtual-terminal-form/VirtualTerminalForm'
import InvoiceForm from '../invoice-form/InvoiceForm'
import APIResponse from '../../../../templates/components/APIResponse';
import AddRecurringPlan from '../../transactions/terminals/installment-terminal/AddRecurringPlan';

const AddInvoice = (props) => {
    const [showVirtTrans, setShowVirtTrans] = useState(false)
    const [invoice, setInvoice] = useState()
    const [isLoader, setIsLoader] = useState(false)
    const [apiResponse, setApiResponse] = useState()
    const [initialData, setInitialData] = useState(props.initialData||{})
    const [collectPaymentClicked, setCollectPaymentClicked] = useState(false)
    const [recurringPlan, setRecurringPlan] = useState(false)
    const [recurringPlanType, setRecurringPlanType] = useState(false)
    const [close, setClose] = useState(false)
    const [nextOperation, setNextOperation] = useState(0)
    const [toastOnSuccess, setToastOnSuccess] = useState(true)

    const onSuccess = (message) => {
        if (nextOperation == 2) {
            setNextOperation(0)
            setClose(true)
        } else {
            if (props.refresh) {
                props.refresh()
            }
            if (props.onClose) {
                props.onClose()
            }
            if (props.exitHandler) {
                props.exitHandler()
            }
        }
    }

    const closeHandler = () => {
        if (isLoader) return; // Prevent multiple submissions
        
        setIsLoader(true);
        setToastOnSuccess(true); // Show toast for closeHandler
        let reqObj = { closeReason: 'Close invoice' }
        InvoiceService.closeAndWriteOff(invoice?.id, reqObj)
            .then(res => {
                setClose(false);
                setApiResponse(res);
            })
            .catch(err => {
                setClose(false);
                setApiResponse(err);
            }).finally(() => {
                setIsLoader(false);
            });
    }

    const addInvoiceSubmit = (data, selectedPatient, items,providerId, invoiceType,isPaymentClicked, paymentType) => {
        if (isLoader) return; // Prevent multiple submissions
        
        setIsLoader(true)
        setToastOnSuccess(true); // Show toast for regular add
        return saveInvoice(data, selectedPatient, items, providerId, invoiceType, isPaymentClicked, paymentType)
            .then((res) => {
                setIsLoader(false)
                setInvoice(res.data)
                setCollectPaymentClicked(isPaymentClicked?isPaymentClicked:false)
                setApiResponse(res)
                if(isPaymentClicked)
                {   
                     {/*paymentType = 1 installment and 3 subscription  */}
                     if(paymentType) setRecurringPlanType(paymentType)
                    if(paymentType && [1,3].includes(paymentType)) {
                          return setRecurringPlan(true);
                        }
                        else{
                            return setShowVirtTrans(true);
                        }
                }
            })
            .catch((err) => {
                setIsLoader(false)
                setApiResponse(err);
            });
    }

    const onCloseInvoice = (data, selectedPatient, items, providerId) => {
        if (isLoader) return; // Prevent multiple submissions
        
        setIsLoader(true)
        setNextOperation(2);
        setToastOnSuccess(false); // Don't show toast for onCloseInvoice save
        return saveInvoice(data, selectedPatient, items, providerId, 0, false, null)
            .then((res) => { 
                if (res?.data) setInvoice(res?.data);
                setApiResponse(res);
                setIsLoader(false); 
            })
            .catch((err) => { 
                setIsLoader(false)
                setApiResponse(err);
            });
    }

    const saveInvoice = (data, selectedPatient, items, providerId, invoiceType, isPaymentClicked, paymentType) => {
        let reqObj = data
        if (reqObj.id) {
            reqObj.appointmentId = reqObj.id;
        }
        reqObj.autoClaimStatus = false
        reqObj.doctorId = items.find(obj => obj.doctorId !== undefined)?.doctorId || providerId
        reqObj.invoiceDate = data.invoiceDate ? new Date(data.invoiceDate) : new Date()
        reqObj.dueDate = data.dueDate ? new Date(data.dueDate) : new Date()
        reqObj.serviceDate = data.serviceDate ? new Date(data.serviceDate) : new Date()
        reqObj.operationType = 2
        reqObj.patientId = selectedPatient.id
        reqObj.patientName = data.patientName || selectedPatient.name || selectedPatient.firstName + ' ' + selectedPatient.lastName
        reqObj.invoiceStatus = data.invoiceStatus || 2
        reqObj.practiceLocationId = data.practiceLocationId
        reqObj.visitDate = new Date(data.serviceDate)
        reqObj.items = items.map(item => {
            const newItem = { ...item };
            if(item.itemType === 4 ){
                //calculated from ui
                newItem.unitPrice = item.feesEachSubTotal ? parseFloat(item.feesEachSubTotal) : 0  
                newItem.taxAmount = item.feesEachTaxAmount ? parseFloat(item.feesEachTaxAmount) : 0
            }else{
                newItem.unitPrice = item.unitPrice ? parseFloat(item.unitPrice) : 0
                //added from appointment create invoice has null doctorId, backend was throwing error 
                if(!newItem.doctorId){
                    delete newItem.doctorId
                }
            }
            
            if(item.itemType === 6 ){
                //tip item
                newItem.name = item.name || "Tip"
            }else{
                newItem.taxPercent = item.taxPercent ? parseFloat(item.taxPercent) : 0
                newItem.discount = item.discount ? parseFloat(item.discount) : 0
                newItem.quantity = item.quantity ? parseFloat(item.quantity) : 1
                newItem.feeAmount = item.feeAmount ? parseFloat(item.feeAmount) : 0
                newItem.feePercentage = item.feePercentage ? parseFloat(item.feePercentage) : 0
            }
            newItem.chartNotesId = item.chartNotesId
            return newItem
        })
        reqObj.taxAmount = data.itemTotalTax
        if (invoiceType == 1) {
            reqObj.isCreditBalance = true
        }
        return InvoiceService.addInvoice(reqObj);
    }

    useEffect(() => {
        if (isLoader === true) {
            setTimeout(() => {
                if (isLoader === true) {
                    setIsLoader(false)
                }
            }, 30000)
        }
    }, [isLoader])

    useEffect(()=>{
        if(props.initialData){
            setInitialData(props.initialData)
        }
    }
    ,[props.initialData])
    return (
        <div>
            <InvoiceForm isLoader={isLoader} appointmentId={props.appointmentId || null} selectPatientDisabled={props.selectPatientDisabled} hideCancel={props.hideCancel} initialData={initialData} isModal={props.isModal} onClose={() => { if (props.onClose) { props.onClose() } }} submitLabel="Add" submitHandler={addInvoiceSubmit} onCloseInvoice={onCloseInvoice}/>
            <ModalBox open={showVirtTrans && invoice} onClose={() => {
                setShowVirtTrans(false); if (props.onClose) {
                    props.onClose()
                }
            }}
            title="Collect Payment"
            >
                <VirtualTerminalForm initialData={{ ...invoice, taxAmount: invoice?.itemTotalTax, adjustedUnpaidAmount: invoice?.adjustedUnpaidAmount ? invoice?.adjustedUnpaidAmount : invoice?.finalAmount }} onClose={() => {
                    setShowVirtTrans(false); if (props.onClose) {
                        props.onClose()
                    }
                }} size="large" isModal />
            </ModalBox>
            <ModalBox open={recurringPlan && invoice } onClose={() => { setRecurringPlan(false) ;
                if (props.onClose) {
                    props.onClose()
                }
            }} title={recurringPlanType == 1 ? "Create Payment Plan" : "Subscription"}>
                {/*recurringPlanType = 1 installment and 3 subscription  */}
                <AddRecurringPlan transactionType={recurringPlanType} initialData={invoice} onClose={() => { setRecurringPlan(false); 
                if (props.onClose) {
                    props.onClose()
                }
                }} isModal />
            </ModalBox>
            <APIResponse apiResponse={apiResponse} toastOnSuccess={toastOnSuccess} onSuccess={collectPaymentClicked?'':onSuccess} />
            
            <ModalBox open={close} onClose={() => { setClose(false) }} size="tiny" title="Close Invoice">
                <div className='col-12'>
                    The invoice has been created. Are you sure you want to close it?
                </div>
                <div className='col-12 d-flex justify-content-between mt-3'>
                    <div className='col-auto'>
                        <button
                            className='btn btn-primary'
                            onClick={(e) => { e.preventDefault(); closeHandler(); }}
                            disabled={isLoader}
                        >
                            Yes
                        </button>
                    </div>
                    <div className="col-auto">
                        <button 
                            className='btn btn-secondary' 
                            onClick={e => { e.preventDefault(); 
                                setClose(false); 
                                //once invoice created close modal should also close the add invoice modal - as invoice is already created, it should not remain in add mode - should reopen in edit mode if needed
                                if(props.onClose) { props.onClose() } 
                            }}
                            disabled={isLoader}
                        >
                            No
                        </button>
                    </div>
                </div>
            </ModalBox>
        </div>
    )
}
export default AddInvoice